import * as React from 'react'
import moment from 'moment'
import { FinancialOverview } from './FinancialOverview'
import { PaymentTypes } from './PaymentTypes'
import { AverageCart } from './AverageCart'
import { NumberOfSales } from './NumberOfSales'
import { Skeleton, Row, Col } from 'antd'
import Helmet from 'react-helmet'
import { SalesGraph } from '../SalesGraph'

interface Props {
  companyId: number
  startDate: string
  endDate: string
  locationIds: number[]
}

interface PropsWithDateString {
  startDate: string
  endDate: string
  companyId: number
  locationIds: number[]
  children?: React.ReactNode
}

interface State {
  propsWithDateString?: PropsWithDateString
}

export class SalesReportV2 extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      propsWithDateString: undefined,
    }
  }

  componentDidMount = () => {
    // Cube.js works best when sending a YYYY-MM-DD date string instead of a Javascript date object
    const propsWithDateString = {
      ...this.props,
      startDate: moment(this.props.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.props.endDate).format('YYYY-MM-DD'),
    }

    this.setState({ propsWithDateString })
  }

  render() {
    const { propsWithDateString } = this.state
    const { startDate, endDate, companyId, locationIds } = this.props

    return (
      <>
        <Row type='flex' style={{ marginRight: '-1rem' }}>
          <Helmet>
            <title>Reports | Summary</title>
            <meta name='page-loaded' content='true' />
          </Helmet>
          {propsWithDateString ? (
            <>
              <Col xl={12} lg={24} md={24} sm={24} className='d-flex'>
                <FinancialOverview
                  startDate={startDate}
                  endDate={endDate}
                  companyId={companyId}
                  locationIds={locationIds}
                />
              </Col>
              <Col xl={12} lg={24} md={24} sm={24} className='d-flex'>
                <PaymentTypes {...propsWithDateString} />
              </Col>

              <>
                <Col xl={12} lg={24} md={24} sm={24} className='d-flex'>
                  <NumberOfSales {...propsWithDateString} />
                </Col>
                <Col xl={12} lg={24} md={24} sm={24} className='d-flex'>
                  <AverageCart {...propsWithDateString} />
                </Col>
              </>
            </>
          ) : (
            <Skeleton active />
          )}
        </Row>
      </>
    )
  }
}
